import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { history }  from '../routers/AppRouter';
import { setActiveEvent }  from '../actions/event';


// The MuiTheme allows me to change color of MuiButton to light gray
const theme = createMuiTheme({
  typography: {
      useNextVariants: true,
  },
});

const styles = theme => ({
  MuiButton: {
    color: '#7F8C8D',
    '&:focus': { 'outline': 'none'},
  },
  MuiList: {
    color: '#7F8C8D',
    
  }
});

class MuiVertMenu extends React.Component {
  state = {
    anchorEl: null,
    eventId: {}
  };

  //*************************************************************
  // Event Handlers
  //*************************************************************
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget,
                    eventId:  this.props.eventId
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleGotoEvent = () => {
    /* set the active event to selected event */
    let eventInfoObject = this.findEventInList(this.state.eventId);
    this.props.setActiveEvent(eventInfoObject);
    /* route user to eventinfo page */
    history.push("/eventmanage/event");
    /* This closes menu */
    this.setState({ anchorEl: null });
  };

  handleGotoPeople = () => {
    /* set the active event to selected event */
    let eventInfoObject = this.findEventInList(this.state.eventId);
    this.props.setActiveEvent(eventInfoObject);
    /* route user to eventinfo page */
    history.push("/eventmanage/people");
    /* This closes menu */
    this.setState({ anchorEl: null });
  };

  handleGotoInvites = () => {
    /* set the active event to selected event */
    let eventInfoObject = this.findEventInList(this.state.eventId);
    this.props.setActiveEvent(eventInfoObject);
    history.push("/eventmanage/invites");
    //This closes menu
    this.setState({ anchorEl: null });
  };

  handleGotoLists = () => {
    let eventInfoObject = this.findEventInList(this.state.eventId);
    this.props.setActiveEvent(eventInfoObject);
    history.push("/eventmanage/lists");
    //This closes menu
    this.setState({ anchorEl: null });
  };

  handleDeleteEvent = () => {
    // call function prop to show modal
    let eventInfoObject = this.findEventInList(this.state.eventId); 

    this.props.dashboardOpenModal(eventInfoObject);
    // history.push("/eventmanage/lists");
    //This closes menu
    this.setState({ anchorEl: null });
   
  };

  //*************************************************************
  // Help function(s)
  //*************************************************************
  findEventInList = (list) => {
    let { eventId } = this.state;
    let events = this.props.event.list;         /* get event list */
    let event = events.find(function(event) {   /* find event that matches eventId passed */
        return event._id === eventId;
    });
    return event ? event : {};
  }

  //*************************************************************
  // render() method
  //*************************************************************
  render() {
    const { anchorEl } = this.state;
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <Button className={classes.MuiButton}
            aria-owns={anchorEl ? 'simple-menu' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
                    <MoreVertIcon />
          </Button>
        
          <Menu className={classes.MuiList}
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            <MenuItem onClick={this.handleGotoEvent}>Event</MenuItem>
            <MenuItem onClick={this.handleGotoPeople}>People</MenuItem>
            <MenuItem onClick={this.handleGotoLists}>Lists</MenuItem>
            <MenuItem onClick={this.handleGotoInvites}>Invites</MenuItem>
            <MenuItem onClick={this.handleDeleteEvent}>Delete Event</MenuItem>
          </Menu>
        </div>
      </MuiThemeProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setActiveEvent:  (eventId) => dispatch(setActiveEvent(eventId))
})
const mapStateToProps = (state) => {
  return {
      event: state.event
  };
};


// export default MuiVertMenu;
// export default withStyles(styles)(MuiVertMenu);
// export default connect(null, mapDispatchToProps)(withStyles(styles)(MuiVertMenu));
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MuiVertMenu));


// WEBPACK FOOTER //
// ./src/components/MuiVertMenu.js